import { Injectable } from '@angular/core';
import { Configuration, ConfigurationParameters } from '../api-client/configuration';
import { AppSettingsService } from '../services/app-settings.service';

/**
 * Dynamic Configuration that gets basePath from AppSettingsService at runtime
 * instead of at construction time. This ensures the basePath is available
 * after APP_INITIALIZER has loaded the settings.
 */
@Injectable()
export class DynamicApiConfiguration extends Configuration {
	constructor(private appSettingsService: AppSettingsService, configurationParameters: ConfigurationParameters = {}) {
		super(configurationParameters);
		// Delete the basePath property so we can use a getter instead
		delete (this as any).basePath;
		// Define a getter that returns the dynamic value
		Object.defineProperty(this, 'basePath', {
			get: () => this.appSettingsService.apiBaseUrl || '',
			enumerable: true,
			configurable: true
		});
	}
}
